import { FormCol, TextControl, InfoTooltip, useScopedSelector, SafeHtml, FormRow } from 'ia-react-core';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { BusinessLine } from '../../../../../interfaces/BusinessLine';
import { NewMessagePageState } from '../../../../../interfaces/NewMessagePageState';

export interface ContractNumberRowProps { disabled?: boolean }

const ContractNumberRow: FC<ContractNumberRowProps> = ({ disabled }) => {
  const { t } = useTranslation('NewMessagePage');
  const { search } = useLocation();
  const businessLine: BusinessLine = useScopedSelector((state: NewMessagePageState) => state.mailFormValues?.businessLine);
  const validationMessage = useMemo(() => <SafeHtml>{businessLine?.contractErrorMessage}</SafeHtml>, [businessLine?.contractErrorMessage]);
  const toolTip = useMemo(() => disabled ? null : <InfoTooltip tip={validationMessage} />, [disabled, validationMessage]);
  const regexValidator = new RegExp(businessLine?.contractFormat);
  const defaultValue = new URLSearchParams(search).get('defaultcontractnumber');

  return (
    <FormRow>
      <FormCol label={t('contractNumber')} tip={toolTip} labelMarginBottom={36}>
        <TextControl
          disabled={disabled}
          name="contractText"
          validators={{ regex: (value: string) => !value || regexValidator.test(value) }}
          validationMessages={{ regex: t('contractNumberErrorMessage') }}
          defaultValue={defaultValue ?? ''}
        />
      </FormCol>
    </FormRow>
  );
};
export default ContractNumberRow;
